import { DataTable, Column, Skeleton } from 'primereact';
import {getLink} from "../../../Commons/Scripts/Utils/link";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";
import {RadioButtonField} from "../../../Commons/Scripts/Componentes/RadioButtonField";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";
import {Message, MessageProvider, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {ImpuestoReporteService} from "../Services/impuesto-reporte-service";
import React,{useState,useEffect} from 'react';
import {formatear2Decimales} from "../../../Commons/Scripts/Utils/formatear";

const origin = window.location.origin;

function TablaReporte607({ reporte, loading }) {
  const columnas = [
    {
      header: "Id",
      field: "Id",
      key: "Id",
      createLink: (item) => getLink("Factura", item.Id),
      alignRight: true,
      noMinWith: true,
    },
    {
      header: "Cliente",
      field: "ClienteNombre",
      key: "ClienteNombre",
    },
    {
      header: "RNC o Cedula",
      field: "RNCoCedula",
      key: "RNCoCedula",
      alignRight: true,
    },
    {
      header: "Tipo Identificacion",
      field: "TipoIdentificacion",
      key: "TipoIdentificacion",
      alignRight: true,
      noMinWith: true,
    },
    {
      header: "Numero Comprobante Fiscal",
      field: "NCF",
      key: "NCF",
      createLink: (item) => getLink("Factura", item.Id),
    },
    { header: "NCF Modificado", field: "NCFModificado", key: "NCFModificado" },
    { header: "Tipo Ingreso", field: "TipoIngreso", key: "TipoIngreso", alignRight: true },
    { header: "Fecha Comprobante", field: "FechaComprobante", key: "FechaComprobante", alignRight: true },
    { header: "Fecha Retencion", field: "FechaRetencion", key: "FechaRetencion", alignRight: true },
    { header: "Monto Facturado", field: "MontoFacturado", key: "MontoFacturado", esNumerico: true },
    { header: "ITBIS Facturado", field: "ItbisFacturado", key: "ItbisFacturado", esNumerico: true },
    {
      header: "Retencion Renta por Terceros",
      field: "RetencionRentaPorTerceros",
      key: "RetencionRentaPorTerceros",
      esNumerico: true,
    },
    {
      header: "ITBIS Retenido por Terceros",
      field: "ItbisRetenidoPorTerceros",
      key: "ItbisRetenidoPorTerceros",
      esNumerico: true,
    },
    { header: "ISR Percibido", field: "ISRPercibido", key: "ISRPercibido", esNumerico: true },
    {
      header: "Impuesto Selectivo al Consumo",
      field: "ImpuestoSelectivoAlConsumo",
      key: "ImpuestoSelectivoAlConsumo",
      esNumerico: true,
    },
    { header: "Otros Impuestos", field: "OtrosImpuestos", key: "OtrosImpuestos", esNumerico: true },
    { header: "Monto Propina Legal", field: "MontoPropinaLegal", key: "MontoPropinaLegal", esNumerico: true },
    { header: "Efectivo", field: "Efectivo", key: "Efectivo", esNumerico: true },
    {
      header: "Cheque/Transf. o Deposito",
      field: "ChequeoTransferencia",
      key: "ChequeoTransferencia",
      esNumerico: true,
    },
    { header: "Tarjeta Debito o Credito", field: "Tarjeta", key: "Tarjeta", esNumerico: true },
    { header: "Venta a Credito", field: "Credito", key: "Credito", esNumerico: true },
    { header: "Bono o Certificado de Regalo", field: "Bonos", key: "Bonos", esNumerico: true },
    { header: "Permuta", field: "Permuta", key: "Permuta", esNumerico: true },
    { header: "Otras formas de Venta", field: "OtraVenta", key: "OtraVenta", esNumerico: true },
  ];

  if (loading) {
    return (
      <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
        <Column body={<Skeleton style={{ height: "40px" }} />} />
      </DataTable>
    );
  }

  return (
    <DataTable id="grid" value={reporte} emptyMessage="No se han encontrado resultados" sortMode="multiple">
      {columnas.map(
        ({ key, field, header, esNumerico = false, alignRight = false, noMinWith = false, createLink = null }) => {
          const style = {
            minWidth: noMinWith ? undefined : "7rem",
            textAlign: esNumerico ? "right" : alignRight ? "right" : undefined,
          };

          return (
            <Column
              field={field}
              style={style}
              headerClassName={esNumerico ? "alinear-derecha" : alignRight ? "alinear-derecha" : undefined}
              key={key}
              body={(item) => {
                if (createLink) {
                  return (
                    <a className="link" href={createLink(item)} target="_blank">
                      {item[field]}
                    </a>
                  );
                }

                if (esNumerico) {
                  return <span>{formatear2Decimales(item[field])}</span>;
                }

                return <span>{item[field]}</span>;
              }}
              header={header}
              footer={() => {
                if (!esNumerico) {
                  return null;
                }

                const total = reporte?.reduce((acc, item) => acc + item[field], 0);
                return <span>{formatear2Decimales(total)}</span>;
              }}
              sortable
            ></Column>
          );
        }
      )}
    </DataTable>
  );
}

function TablaReporte607Resumen({ resumen, loading }) {
  if (loading) {
    return null;
  }

  return (
    <table className="table">
      <tbody>
        <tr>
          <th className="th">RNC o Cedula</th>
          <td className="td">{resumen?.RNCoCedula}</td>
        </tr>
        <tr>
          <th className="th">Periodo</th>
          <td className="td">{resumen?.Periodo}</td>
        </tr>
        <tr>
          <th className="th">Cantidad de Registros</th>
          <td className="td">{resumen?.CantidadRegistros}</td>
        </tr>
      </tbody>
    </table>
  );
}

function Formulario({ loading, anios, meses, onSubmit, valorInicial = {}, onChange, where }) {

  const form = useForm(valorInicial);

  const [mostrarMeses, setMostrarMeses] = useState(false);

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.REPORTE_607, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.REPORTE_607, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.REPORTE_607, "CSV");

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  const handleChange = (values) => {
    if (values.tipo === "mes") {
      setMostrarMeses(true);
    } else {
      setMostrarMeses(false);
    }

    onChange(values);
  };

  return (
    <SimpleForm formulario={form} onChange={handleChange}>
      <div className="row">
        <div className="label">Tipo</div>
        <div className="container-rb">
          <RadioButtonField name="tipo" label="Por año" value="anio" />
          <RadioButtonField name="tipo" label="Por mes" value="mes" />
        </div>
      </div>
      <div className="row">
        <SelectField
          name="anio"
          opciones={anios || []}
          placeholder="Todos"
          label="Año"
          isLoading={loading}
          width="100px"
        />
        {mostrarMeses && (
          <SelectField
            name="mes"
            opciones={meses || []}
            label="Mes"
            placeholder="Todos"
            isRow
            isLoading={loading}
            width="125px"
          />
        )}
      </div>
      <div className="container-btn">
        <Button2 texto="Buscar" icono="buscar" onClick={handleSubmit} />
        <Button2 texto="PDF" icono="imprimir" loading={loadingPdf} onClick={() => handlePdf(where)} />
        <Button2 texto="Excel" icono="excel" loading={loadingExcel} onClick={() => handleExcel(where)} />
        <Button2 texto="CSV" icono="excel" loading={loadingCsv} onClick={() => handleCsv(where)} />
      </div>
    </SimpleForm>
  );
}

export function Reporte607() {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();

  const [loadingDatos, setLoadingDatos] = useState(false);
  const [anios, setAnios] = useState();
  const [meses, setMeses] = useState();

  const [loading, setLoading] = useState(false);
  const [reporte, setReporte] = useState();
  const [where, setWhere] = useState({ anio: new Date().getFullYear(), mes: 1 });

  const [resumen, setResumen] = useState();

  useEffect(() => {
    setLoading(true);
    clearMessages();

    ImpuestoReporteService.consultarReporte607(where)
      .then((res) => {
        setReporte(res?.Resultados);
        setResumen(res?.Resumen);
      })
      .catch((err) => {
        handleException(err);
      })

      .finally(() => {
        setLoading(false);
      });
  }, [where]);

  useEffect(() => {
    setLoadingDatos(true);
    clearMessages();

    Promise.all([ImpuestoReporteService.consultarAnios(), ImpuestoReporteService.consultarMeses()])
      .then((res) => {
        const anios = res[0]?.map((anio) => {
          return {
            value: anio.id,
            label: anio.text,
          };
        });
        const meses = res[1]?.map((mes) => {
          return {
            value: mes.id,
            label: mes.text,
          };
        });

        setAnios(anios);
        setMeses(meses);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        setLoadingDatos(false);
      });
  }, []);

  return (
    <div>
      <Message messages={messages} type={typeMessages} />
      <Formulario
        anios={anios}
        meses={meses}
        loading={loadingDatos}
        onSubmit={(formulario) => {
          const where = {
            anio: formulario.anio?.value != "-1" ? formulario.anio?.value : null,
            mes: formulario.mes?.value != "-1" && formulario.tipo == "mes" ? formulario.mes?.value : null,
          };
          setWhere(where);
        }}
        valorInicial={{
          tipo: "mes",
          anio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
          mes: { value: 1, label: "Enero" },
        }}
        onChange={(formulario) => {}}
        where={where}
      />
      <TablaReporte607Resumen resumen={resumen} loading={loading} />
      <TablaReporte607 reporte={reporte} loading={loading} />
    </div>
  );
}